// extracted by mini-css-extract-plugin
module.exports = {"productAdapterType":"__3PxmFMQ3","wrap":"GEbK0bl0","key":"Z1ibZq52","tags":"E4g8SNtP","val":"if8Is2Fn"};